import { APP_SERVICE_IDS, AVAILABLE_SERVICES } from '../constants/app';

export const getAvailableServices = ({ isApp }) =>
    isApp
        ? AVAILABLE_SERVICES.filter(({ id }) => APP_SERVICE_IDS.includes(parseInt(id)))
        : AVAILABLE_SERVICES;
